import { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { getListingCount } from "@/src/services/listingService";

import FilterBox from "components/listing-search/filter-box";
import FilterItems from "components/listing-search/filter-items";
import CategoryFilter from "components/listing-search/category-filter";

import styles from "components/listing-search/sidebar/styles.module.css";

const FilterSidebar = ({
  listingData,
  categoryTree,
  listingCountItems,
  pageType,
  screenType,
  filters,
  isProjectPage,
}) => {
  const [listingCategoryCount, setListingCategoryCount] = useState(listingCountItems);
  const [isLoadingListingCategoryCount, setIsLoadingListingCategoryCount] = useState(false);

  const { searchCriteria, total, listingCard, projectCards } = listingData || {};
  const totalCount = total || listingCard?.total || projectCards?.total || 0;

  const getModifiedPath = (pageHref, originPath) => {
    const url = new URL(pageHref);
    return originPath + url.search;
  };

  const getListingCountItems = async () => {
    setIsLoadingListingCategoryCount(true);

    const pageType = isProjectPage ? "project" : "listing";
    const pageHref = window.location.href;
    const originPath = window.location.pathname;
    const modifiedPath = getModifiedPath(pageHref, originPath);

    try {
      const response = await getListingCount(modifiedPath, pageType);
      setListingCategoryCount(response?.listingCountItems);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoadingListingCategoryCount(false);
    }
  };

  useEffect(() => {
    getListingCountItems();
  }, [listingData]);

  return (
    <div className={styles.wrapper}>
      <FilterBox isTypeView>
        <div className={styles.title}>Kategoriler</div>
        <CategoryFilter
          listingCountItems={listingCategoryCount}
          criteria={searchCriteria}
          categoryTree={categoryTree}
          totalCount={totalCount}
          screenType={screenType}
          isLoadingListingCategoryCount={isLoadingListingCategoryCount}
        />
      </FilterBox>
      <FilterBox>
        <FilterItems criteria={searchCriteria} pageType={pageType} screenType={screenType} filters={filters} />
      </FilterBox>
    </div>
  );
};

FilterSidebar.propTypes = {
  categoryTree: PropTypes.array,
  listingData: PropTypes.object,
  listingCountItems: PropTypes.array,
  screenType: PropTypes.string,
  filters: PropTypes.object,
  pageType: PropTypes.string,
  isLoadingListingCategoryCount: PropTypes.bool,
};

export default FilterSidebar;
